// Indian number formatting helpers
export const fmtIN = (n) => new Intl.NumberFormat('en-IN').format(Math.round(n));

export const shortIN = (n) => {
  if (n >= 1e7) return (n / 1e7).toFixed(1).replace(/\.0$/, '') + ' Cr';
  if (n >= 1e5) return (n / 1e5).toFixed(1).replace(/\.0$/, '') + ' L';
  if (n >= 1e3) return (n / 1e3).toFixed(1).replace(/\.0$/, '') + ' K';
  return String(Math.round(n));
};

export const cr = (n) => '₹' + (+n.toFixed(1)).toLocaleString('en-IN') + ' Cr';
export const crFull = (n) => '₹' + fmtIN(n * 1e7);

export const fmtDate = (iso) => {
  const d = new Date(iso);
  return d.getDate() + ' ' + d.toLocaleString('en-IN', { month: 'short' }) + ' ' + d.getFullYear();
};

export const daysFrom = (iso, today = new Date('2026-06-05')) =>
  Math.round((new Date(iso) - today) / 86400000);

// RdYlGn utilisation color (ColorBrewer diverging)
export const utilColor = (pct) =>
  pct >= 75 ? '#1A9641' :
  pct >= 55 ? '#A6D96A' :
  pct >= 40 ? '#FDAE61' : '#D7191C';
